import React, { useState } from "react";
import { Button } from "devextreme-react";
import "remixicon/fonts/remixicon.css";

const MonitorActions = ({
  play,
  pause,
  isPlaying,
  Prev,
  Next,
  isActiveNextButton,
  isActivePrevButton,
  backwardTenPages,
  forwardTenPages,
}) => {
  const [selectedIndex, setSelectedIndex] = useState(0);

  const playPause = () => {
    if (!isPlaying) {
      play();
    } else {
      pause();
    }
  };

  const TooltipButton = ({ onClick, icon, tooltip, disabled = false, customRender }) => (
    <div className="lg:w-[36px] w-full relative group">
      <Button
        onClick={onClick}
        icon={icon}
        stylingMode="outlined"
        width="100%"
        disabled={disabled}
        render={customRender}
      />
      <div className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 hidden group-hover:block bg-black text-white text-xs px-2 py-1 rounded whitespace-nowrap z-50">
        {tooltip}
      </div>
    </div>
  );

  return (
    <React.Fragment>
      <div className="flex flex-wrap w-full gap-1 sm:gap-3 justify-center md:justify-center">
        <div className="flex lg:w-auto w-full">
          <TooltipButton
            onClick={backwardTenPages}
            tooltip="Previous 10 pages"
            customRender={() => (
              <div className="flex items-center justify-center">
                <i class="ri-replay-10-line text-lg"></i>
              </div>
            )}
          />
          <TooltipButton
            onClick={Prev}
            tooltip="Previous page"
            disabled={isActivePrevButton}
            customRender={() => (
              <div className="flex items-center justify-center">
                <i class="ri-play-reverse-line text-lg"></i>
              </div>
            )} 
          />
          <TooltipButton
            onClick={playPause}
            tooltip={isPlaying ? "Pause" : "Play"}
            customRender={() => (
              <div className="flex items-center justify-center">
                <i className={`ri-${isPlaying ? "pause" : "play"}-fill`} style={{ fontSize: 20 }} />
              </div>
            )}
          />
          <TooltipButton
            onClick={Next}
            tooltip="Next page"
            disabled={isActiveNextButton}
            customRender={() => (
              <div className="flex items-center justify-center">
                <i class="ri-play-line text-lg"></i>
              </div>
            )}
          />
          <TooltipButton
            onClick={forwardTenPages}
            tooltip="Next 10 pages"
            customRender={() => (
              <div className="flex items-center justify-center">
                <i class="ri-forward-10-line text-lg"></i>
              </div>
            )}
          />
        </div>
      </div>
    </React.Fragment>
  );
};

export default MonitorActions;
